import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import SidebarDownloadDocButton from 'RankBrain2SidebarNavbar/SidebarDownloadSection/SidebarDownloadDocButton';

const sidebarSectionContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 25,
  paddingBottom: 25,
};

class RankBrain2EditorialDownloadSection extends React.PureComponent {
  static init(id, props) {
    ReactDOM.render(
      <RankBrain2EditorialDownloadSection {...props} />,
      document.getElementById(id),
    );
  }

  render() {
    return (
      <div>
        <div
          className="section-container editorial-download-banner"
          style={sidebarSectionContainerStyle}
        >
          <h4>
            Download a Free {this.props.documentName}
          </h4>
          <SidebarDownloadDocButton
            slug={this.props.downloadSlug || this.props.slug}
            imgSrc="/images/rank-brain-2/download-word-2x.png"
            imgSrcHover="/images/rank-brain-2/download-word-hover-2x.png"
            text="Word"
            format="docx"
          />
          <SidebarDownloadDocButton
            slug={this.props.downloadSlug || this.props.slug}
            imgSrc="/images/rank-brain-2/download-pdf-2x.png"
            imgSrcHover="/images/rank-brain-2/download-pdf-hover-2x.png"
            text="PDF"
            format="pdf"
          />
        </div>
      </div>
    );
  }
}

RankBrain2EditorialDownloadSection.defaultProps = {
  downloadSlug: '',
  documentName: '',
};

RankBrain2EditorialDownloadSection.propTypes = {
  slug: PropTypes.string.isRequired,
  documentName: PropTypes.string.isRequired,
  downloadSlug: PropTypes.string,
};

export default RankBrain2EditorialDownloadSection;



// WEBPACK FOOTER //
// ./src-react/RankBrain2EditorialDownloadSection/index.jsx